import { useMediaQuery } from '@react-hookz/web';
import Image from 'next/image';

import { usePaywallContext } from '~context/paywall';
import type { PaymentReasonType } from '~features/annals/enums/payment';
import { PaymentReason } from '~features/annals/enums/payment';
import { usePromoEvent } from '~features/promoEvent';
import { useIsSubscriber } from '~features/tags';
import { useTranslations } from '~i18n/hooks';
import { ButtonSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary';

import { PromoHeadButtonCustom, StyledText } from './styles';

type Props = {
	botClientId?: string;
	reasonType: PaymentReasonType;
};

export const PromoHeadButton = ({ botClientId, reasonType }: Props) => {
	const t = useTranslations('ProfileMenu');

	const mobile = useMediaQuery('screen and (max-width: 767px)');
	const desktop = useMediaQuery('screen and (min-width: 1024px)');
	const mini = !mobile && !desktop;

	const { active, headerSubscriptionText } = usePromoEvent();
	const isSubscriber = useIsSubscriber();

	const { openPaywall } = usePaywallContext();

	const customPromo = !isSubscriber;
	const eventPromo = active && headerSubscriptionText;
	const customPromoCode = customPromo
		? t('subscriptionPromoButtonTitle').split(': ')[1]
		: undefined;

	const handleClick = openPaywall({
		reason: customPromo ? PaymentReason.TopMenuPromo : PaymentReason.TopMenu,
		reasonType,
		prefer: 'subscription',
		botClientId,
		defaultPromocode: customPromoCode,
	});

	return customPromo ? (
		<PromoHeadButtonCustom mini={mini} onClick={handleClick}>
			{!mini && (
				<StyledText size="S">{t('subscriptionPromoButtonTitle')}</StyledText>
			)}
			<Image
				width={mini ? 16 : 20}
				height={mini ? 20 : 25}
				src="/img/promo-code-gift.png"
				alt=""
				quality={100}
			/>
		</PromoHeadButtonCustom>
	) : (
		<ButtonSecondary
			data-name="subscription-button"
			size="M"
			onClick={handleClick}
		>
			{eventPromo ? headerSubscriptionText : t('subscriptionButtonTitle')}
		</ButtonSecondary>
	);
};
